export const MARKETING_EMAIL = 'marketing@weplayarcade.com';
export const ROOT_EMAIL = 'root@weplayarcade.com';

export const isRootUser = (user?: { email?: unknown }): boolean =>
    typeof user?.email === 'string' && user.email.trim().toLowerCase() === ROOT_EMAIL;

export type UserRoleName = 'MARKETING' | 'ADMIN';

export const getUserRole = (user?: any): UserRoleName => {
    return user?.email?.toLowerCase?.() === MARKETING_EMAIL ? 'MARKETING' : 'ADMIN';
};
